import {
  AngeplusLogo,
  Content,
  SkeletonHeaderHome,
} from '@ferreri/prever-component-lib';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import {
  useSendAccountToWebView,
  useSendSessionToWebView,
} from '../web-view-message/web-view-message.store';
import { ChatButton } from './ChatButton';
import { PlansSection } from './PlansSection';
import { ProductsSection } from './ProductsSection';

const LinkPlanBanner = dynamic(() => import('contract/linkPlanBanner'));
const HeaderHomeNotification = dynamic<{ image: ReactNode }>(
  () => import('notification/HeaderHomeNotification'),
  { loading: () => <SkeletonHeaderHome /> },
);

export const Home = () => {
  useSendSessionToWebView();
  useSendAccountToWebView();

  return (
    <Content>
      <HeaderHomeNotification image={<AngeplusLogo />} />
      <LinkPlanBanner />
      <PlansSection />
      <ProductsSection />
      <ChatButton />
    </Content>
  );
};
